import { render, staticRenderFns } from "./asset-list.vue?vue&type=template&id=2be0fdd1&scoped=true&"
import script from "./asset-list.vue?vue&type=script&lang=ts&"
export * from "./asset-list.vue?vue&type=script&lang=ts&"
import style0 from "./asset-list.vue?vue&type=style&index=0&id=2be0fdd1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be0fdd1",
  null
  
)

export default component.exports